<template>
  <div>
    <div class="mb-4">
      <aha-breadcrumb :hasMultipleLevels="hasMultipleLevels">
        <aha-breadcrumb-item
          :text="category"
          :clickable="isSecondLevelClickable"
          @click="isSecondLevelClickable ? $emit('clickSecondLevel') : false"
        />
        <!-- Shared with me > Folder level 1 > Folder level n -->
        <span v-for="(objItem, index) in nLevelArray" :key="index">
          <aha-breadcrumb-item
            :text="objItem.folderName"
            v-if="objItem && objItem.folderName && objItem.folderName.length"
            clickable
            @click="$emit('clickNLevel', objItem.folderId)"
            isMultipleLeveledItem
          />
        </span>
        <aha-breadcrumb-item
          :text="text"
          :clickable="clickable"
          @click="$emit('click')"
        />
        <aha-breadcrumb-item
          :text="subText"
          v-if="subText.length"
        />
      </aha-breadcrumb>
      <div class="mt-2 text-lg font-bold flex gap-3">
        <h2 class="presentation-title">
          {{ title ? title : text }}
        </h2>
        <span v-if="scimEnabled" class="scim-badge">SCIM</span>
      </div>
      <div
        class="subtitle mt-1"
        v-if="subTitle.length"
      >
        <span v-tooltip="subTitleTooltip">{{ subTitle }}</span>
      </div>
    </div>
    <div class="mb-4 border-b border-secondary-20" v-if="!noBorder" />
  </div>
</template>

<script>
export default {
  props: {
    hasMultipleLevels: {
      type: Boolean,
      default: false,
    },
    nLevelArray: {
      type: Array,
      default: () => [{}],
    },
    category: {
      type: String,
      default: '',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    subText: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    subTitleTooltip: {
      type: String,
      default: '',
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    isSecondLevelClickable: {
      type: Boolean,
      default: false,
    },
    scimEnabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.presentation-title {
  @apply truncate;
  @media (max-width: 1024px) {
    text-overflow: unset;
    white-space: normal;
  }
}

.subtitle {
  color: #8A8A8A;
  font-family: "Plus Jakarta Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  letter-spacing: 0.2px;
}

.scim-badge {
  height: 32px;
  @apply text-primary-90 bg-primary-20 rounded-lg py-0.5 px-3 text-base
}
</style>
